import React from 'react';
import { useNavigation } from '../context/NavigationContext';
import { legalConfig } from '../../config/legalConfig';
import { Cookie, Shield, Calendar, ArrowLeft, Settings2 } from 'lucide-react';

export const CookiePolicyPage: React.FC = () => {
  const { navigate } = useNavigation();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Link */}
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 text-xs font-semibold text-slate-400 hover:text-white transition-colors mb-8 group"
        >
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" />
          <span>Ana Sayfaya Dön</span>
        </button>

        {/* Header */}
        <div className="border-b border-slate-800 pb-8 mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-amber-500/10 text-amber-400 border border-amber-500/20 mb-4">
            <Cookie className="w-3.5 h-3.5" />
            <span>Çerez ve İzleme Teknolojileri</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight leading-tight">
            ÇEREZ POLİTİKASI
          </h1>
          <div className="mt-4 flex flex-wrap items-center gap-6 text-xs text-slate-400">
            <span className="flex items-center gap-1.5">
              <Shield className="w-3.5 h-3.5 text-amber-400" />
              <span>Hukuki İşletmeci: <strong className="text-slate-200">{legalConfig.companyName}</strong></span>
            </span>
            <span className="flex items-center gap-1.5">
              <Calendar className="w-3.5 h-3.5 text-amber-400" />
              <span>Yürürlük Tarihi: <strong className="text-slate-200">{legalConfig.effectiveDate}</strong></span>
            </span>
            <span className="text-slate-500">Sürüm: {legalConfig.cookieVersion}</span>
          </div>
          <p className="mt-4 text-sm text-slate-300 leading-relaxed">
            {legalConfig.relationshipStatement} Platformumuzda deneyiminizi iyileştirmek, oturum güvenliğini temin etmek ve tercihlerinizin hatırlanmasını sağlamak amacıyla çerezler (cookies) kullanılmaktadır.
          </p>
        </div>

        {/* Content */}
        <div className="prose prose-invert prose-slate max-w-none text-sm leading-relaxed space-y-8 text-slate-300">
          <section className="space-y-3">
            <h2 className="text-base font-bold text-white">1. Çerez (Cookie) Nedir?</h2>
            <p>
              Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler web sitesinin düzgün çalışmasını, oturumunuzun açık kalmasını ve sitenin tercihlerinizi hatırlamasını sağlar.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-base font-bold text-white">2. Platformumuzda Kullanılan Çerez Kategorileri</h2>

            {/* Zorunlu Çerezler */}
            <div className="p-4 rounded-xl bg-slate-900 border border-slate-800 space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-bold text-white text-sm">A. Zorunlu (Kesinlikle Gerekli) Çerezler</span>
                <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
                  Her Zaman Aktif
                </span>
              </div>
              <p className="text-xs text-slate-400">
                Web sitesinin temel işlevlerini yerine getirebilmesi, oturum açma, form güvenliği ve CSRF saldırılarına karşı koruma için zorunludur. Bu çerezler kapatılamaz.
              </p>
              <div className="text-[11px] text-slate-500 font-mono pt-1">
                Örnekler: adio_session, auth_token, cookie_consent_preferences
              </div>
            </div>

            {/* İşlevsel Çerezler */}
            <div className="p-4 rounded-xl bg-slate-900 border border-slate-800 space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-bold text-white text-sm">B. İşlevsel Çerezler</span>
                <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-blue-500/20 text-blue-400 border border-blue-500/30">
                  Kullanıcı Tercihine Bağlı
                </span>
              </div>
              <p className="text-xs text-slate-400">
                Dil tercihleri, tema ayarları ve editör görünüm tercihlerinizin sonraki ziyaretlerinizde hatırlanmasını sağlar.
              </p>
            </div>

            {/* Performans ve Analitik */}
            <div className="p-4 rounded-xl bg-slate-900 border border-slate-800 space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-bold text-white text-sm">C. Performans ve Analitik Çerezler</span>
                <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-purple-500/20 text-purple-400 border border-purple-500/30">
                  İsteğe Bağlı
                </span>
              </div>
              <p className="text-xs text-slate-400">
                Ziyaretçi sayıları, sayfa yüklenme süreleri ve gezinti akışlarını anonim olarak ölçerek platform hızını ve kullanıcı deneyimini optimize etmemize yardımcı olur.
              </p>
            </div>

            {/* Pazarlama Çerezleri */}
            <div className="p-4 rounded-xl bg-slate-900 border border-slate-800 space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-bold text-white text-sm">D. Pazarlama ve Hedefleme Çerezleri</span>
                <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-amber-500/20 text-amber-400 border border-amber-500/30">
                  İsteğe Bağlı (Açık Rıza)
                </span>
              </div>
              <p className="text-xs text-slate-400">
                Yalnızca açık rızanızın bulunması halinde, ilgi alanlarınıza uygun ürün ve kampanya duyurularının sunulması amacıyla kullanılır.
              </p>
            </div>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-white">3. Çerez Tercihlerini Nasıl Yönetebilirsiniz?</h2>
            <p>
              Platformumuzu ilk ziyaret ettiğinizde açılan Çerez Onay Bannerı üzerinden tercihlerinizi belirleyebilirsiniz. Ayrıca tarayıcınızın ayarlarından çerezleri dilediğiniz zaman silebilir veya engelleyebilirsiniz. Ancak zorunlu çerezlerin engellenmesi durumunda platformun bazı kısımları düzgün çalışmayabilir.
            </p>
          </section>
        </div>

        {/* Company Contact */}
        <div className="mt-12 p-6 rounded-2xl bg-slate-900 border border-slate-800 text-xs text-slate-400 space-y-2">
          <p className="font-semibold text-slate-200">İletişim:</p>
          <p>Şirket: <strong className="text-white">{legalConfig.companyName}</strong></p>
          <p>E-Posta: {legalConfig.privacyEmail}</p>
        </div>
      </div>
    </div>
  );
};
export default CookiePolicyPage;
